type DataLayerEvents = 'BetPlaced' | 'RewardUsed' | 'Unknown'

export const getDataLayerPushedEventType = (kambiEvent: KambiEvent): DataLayerEvents => {
  if (kambiEvent.name !== 'dataLayerPushed') return 'Unknown'

  if (isBetPlacedEvent(kambiEvent)) {
    const isRewardUsed = kambiEvent.data.ecommerce.items.some(item => item.reward_type)
    return isRewardUsed ? 'RewardUsed' : 'BetPlaced'
  }

  return 'Unknown'
}

const isBetPlacedEvent = (kambiEvent: KambiEvent): kambiEvent is BetPlacedEvent => {
  const data = kambiEvent.data as BetPlacedEvent['data'] | undefined
  return !!data && data.event === 'purchase' && Array.isArray(data.ecommerce?.items)
}

type BetPlacedEvent = {
  name: 'dataLayerPushed'
  data: {
    event: 'purchase'
    ecommerce: {
      items: {
        reward_type?: string
      }[]
    }
  }
}
